import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_head_icon = _resolveComponent("head-icon");
  const _component_x_button = _resolveComponent("x-button");
  const _component_vxe_modal = _resolveComponent("vxe-modal");
  return _openBlock(), _createBlock(_component_vxe_modal, _mergeProps({
    ref: "modalRef",
    id: _ctx.id,
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.visible = $event)
  }, _ctx.modalProps, _toHandlers(_ctx.dialogEvents)), _createSlots({
    title: _withCtx(() => [_renderSlot(_ctx.$slots, "title", {
      title: _ctx.title
    }, () => [!['notification', 'message'].includes(_ctx.modalProps.type) ? _renderSlot(_ctx.$slots, "icon", {
      key: 0
    }, () => [_createVNode(_component_head_icon, {
      icon: _ctx.icon
    }, null, 8, ["icon"])], true) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(_ctx.modalProps.title), 1)], true)]),
    rightfoot: _withCtx(() => [_renderSlot(_ctx.$slots, "foot-buttons", {}, () => [_createVNode(_component_x_button, _mergeProps(_ctx.buttonProps.ok, _toHandlers(_ctx.buttonEvents.ok)), null, 16), _createVNode(_component_x_button, _mergeProps(_ctx.buttonProps.cancel, _toHandlers(_ctx.buttonEvents.cancel)), null, 16)], true)]),
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps(_ctx.params)), () => [_createTextVNode(_toDisplayString(_ctx.content), 1)], true)]),
    _: 2
  }, [_renderList(Object.keys(_ctx.$slots).filter(k => !['default'].includes(k)), key => {
    return {
      name: key,
      fn: _withCtx(scope => [key === 'leftfoot' ? _renderSlot(_ctx.$slots, "foot-tools", _normalizeProps(_mergeProps({
        key: 0
      }, scope)), undefined, true) : key === 'rightfoot' ? _renderSlot(_ctx.$slots, "foot-buttons", _normalizeProps(_mergeProps({
        key: 1
      }, scope)), undefined, true) : _renderSlot(_ctx.$slots, key, _mergeProps({
        key: key
      }, scope), undefined, true)])
    };
  })]), 1040, ["id", "modelValue"]);
}